module.exports = require("./yav.js");